<script >
import { computed, defineAsyncComponent } from 'vue-demi';
import '@futuweb/quote-charts/lib/SparkChart/style/index.css';
const SparkChart = defineAsyncComponent(() => import('@futuweb/quote-charts/lib/SparkChart'));
const __sfc_main = {};
__sfc_main.props = {
  theme: Number,
  // 白肤-1/黑肤-3
  dataSource: Array,
  chartDataMap: Object,
  selfSelectedMap: Object,
  upDownColor: Number,
  // 红涨绿跌-0/绿涨红跌-1
  header: Object // { show: true, column: [],}
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    usePageType
  } = require('@fegobull/webapi').use;
  const {
    isPC
  } = usePageType();
  const props = __props;
  const column = computed(() => {
    return props.header.column || {};
  });
  const emits = __ctx.emit;
  return {
    isPC,
    column,
    emits
  };
};
__sfc_main.components = Object.assign({
  SparkChart
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div :class="['rank-list', { PC: isPC, dark: theme === 3 }]">
        <ul>
            <li class="rank-header" v-if="header.show">
                <div class="col-name">{{ column.name }}</div>
                <div class="col-right-wrap">
                    <div class="col-trend">{{ column.trend }}</div>
                    <div class="col-increase">{{ column.increase }}</div>
                    <div class="col-icon">{{ column.wch }}</div>
                </div>
            </li>
            <li
                class="rank-item"
                v-for="(item, i) in dataSource"
                :key="item.stockId"
                @click="emits('itemClick', $event, item)"
            >
                <div class="col-name align-left">
                    <div class="rank-item__num">
                        <div v-if="i < 3" :class="`top-3 no__${i + 1}`"></div>
                        <span v-else>{{ i + 1 }}</span>
                    </div>
                    <div class="rank-item__text">
                        <p class="rank-item__stock-name text-over">{{ item.name }}</p>
                        <p class="rank-item__stock-symbol text-over">{{ item.symbol }}</p>
                    </div>
                </div>
                <div class="col-right-wrap">
                    <div class="col-trend align-right">
                        <SparkChart
                            v-if="chartDataMap && chartDataMap[item.stockId]"
                            class="spark-chart"
                            :dataSource="chartDataMap && chartDataMap[item.stockId]"
                            :upDownColor="upDownColor"
                        />
                    </div>
                    <div
                        :class="[
                            'col-increase',
                            'align-right',
                            upDownColor == 0 ? 'red-up' : 'green-up',
                            { up: item.priceChange > 0, down: item.priceChange < 0 }
                        ]"
                    >
                        {{ item.priceChange > 0 ? `+${item.ratioPriceChange}` : item.ratioPriceChange }}
                    </div>
                    <div class="col-icon align-center">
                        <img
                            v-if="selfSelectedMap && selfSelectedMap[item.stockId]"
                            src="./images/selected.png"
                            @click.stop="emits('iconClick', $event, item, true)"
                            alt="selected"
                        />
                        <img
                            v-else
                            src="./images/not-select.png"
                            @click.stop="emits('iconClick', $event, item, false)"
                            alt="not-select"
                        />
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<style lang="less" scoped>
@import './index.less';
</style>
